<script setup lang="ts">
const { activeVariant, activeProduct } = storeToRefs(useProductVariantsStore())

const { data } = useEcommerceCatalogue()

const productVariantPrice = computed(() => getProductPrice(activeVariant, data))
</script>

<template>
  <div v-if="productVariantPrice?.original" class="flex flex-col items-center gap-4">
    <UPrice
      :price="productVariantPrice"
      view-type="list"
    />
    <UProductDiscountedPrice
      v-if="productVariantPrice.discounted"
      :price="productVariantPrice"
      :product="activeProduct"
      show-status-details
      class="font-normal text-dark md:text-product-desktop-price-sm text-product-mobile-price-sm font-national2condensed text-center"
    />
  </div>
</template>
